import Celebration from "./Celebration";

export default function OutputCueBase({ cue, id, children }) {
	return (
		<div
			className={`relative ${
				[true, "true"].includes(cue.interactable) &&
				["onair", "cuedoff"].includes(cue.status)
					? "pointer-events-auto"
					: "pointer-events-none"
			}`}
			data-id={id}
		>
			{(cue.type === "social" || cue.type === "celebration") &&
				(cue.status === "onair" ||
					cue.status === "coming" ||
					cue.status === "going") && (
					<Celebration
						cue={cue}
						type={cue.sponsoredCelebration || cue.celebrationType}
					/>
				)}
			<div className="w-screen h-screen absolute top-0 bottom-0 left-0 right-0">
				{children}
			</div>
		</div>
	);
}
